import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { BaseControl, SelectControl } from '@wordpress/components';

import PanelBody from '../../components/PanelBody';
import ColorPicker from '../../components/ColorPicker';
import Slider from '../../components/Slider';
import { SHAPES } from './shapes';

export default function Inspector({ attributes, setAttributes }) {
  const { shape, shapeSize, shapeColor, shapeGap, labelColor } = attributes;

  const hasShape = shape && shape !== 'none';

  return (
    <InspectorControls>
      <PanelBody title={__('Shape', 'brandy-blocks')} initialOpen>
        <SelectControl
          label={__('Side shape', 'brandy-blocks')}
          value={shape}
          onChange={(value) => setAttributes({ shape: value })}
          options={[
            ...Object.entries(SHAPES).map(([key, { label }]) => ({
              value: key,
              label,
            })),
            { value: 'none', label: __('None', 'brandy-blocks') },
          ]}
          __nextHasNoMarginBottom
          __next40pxDefaultSize
        />

        {/* Nothing below this acts on anything once the shapes are off. */}
        {hasShape && (
          <>
            <Slider
              label={__('Shape size', 'brandy-blocks')}
              value={shapeSize}
              onChange={(value) => setAttributes({ shapeSize: value })}
              min={16}
              max={160}
            />

            <Slider
              label={__('Gap', 'brandy-blocks')}
              value={shapeGap}
              onChange={(value) => setAttributes({ shapeGap: value })}
              min={0}
              max={64}
            />

            <BaseControl.VisualLabel>
              {__('Shape color', 'brandy-blocks')}
            </BaseControl.VisualLabel>
            <ColorPicker
              color={shapeColor}
              onChange={(value) => setAttributes({ shapeColor: value })}
            />
          </>
        )}
      </PanelBody>

      {/*
        Its own panel rather than a third colour under "Shape": the caption is
        the block's other half, and the reference pairs a coloured figure with
        a muted caption — the two colours are set for different reasons.
      */}
      <PanelBody title={__('Caption', 'brandy-blocks')} initialOpen={false}>
        <BaseControl.VisualLabel>
          {__('Caption color', 'brandy-blocks')}
        </BaseControl.VisualLabel>
        <ColorPicker
          color={labelColor}
          onChange={(value) => setAttributes({ labelColor: value })}
        />
      </PanelBody>
    </InspectorControls>
  );
}
